import { Injectable } from '@angular/core';
import { PredefinedAudioService } from '@nimbus-library/features/shared/services/media/predefined-audio.service';

@Injectable({ providedIn: 'root' })
export class UserPreferencesNotificationAudioService extends PredefinedAudioService {}
